var _mask, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandEngland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    fill: "#24356a",
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.78 16.02h30.46v4h-30.46z",
    fill: "#f4f0ed",
    transform: "matrix(-.92 .4 -.4 -.92 41.71 27.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.78 16.02h30.46v4h-30.46z",
    fill: "#f4f0ed",
    transform: "matrix(.92 .4 -.4 .92 8.68 -5.69)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e42a18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 13.08h12.17v1h-12.17z",
    transform: "matrix(-.92 .4 -.4 -.92 55.41 15.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.66 21.84h12.96v1h-12.96z",
    transform: "matrix(-.92 .4 -.4 -.92 28.35 38.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.62 21.24h8.39v1h-8.39z",
    transform: "matrix(.92 .4 -.4 .92 11.06 -9.69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.81 13.94h9.44v1h-9.44z",
    transform: "matrix(.92 .4 -.4 .92 6.38 -1.80)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 20h-13v-4h13v-13h4v13h13v4h-13v13h-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m15.75 20.25h-13v-4.5h13v-13h4.5v13h13v4.5h-13v13h-4.5z",
    fill: "none",
    stroke: "#f4f0ed",
    strokeWidth: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandEngland);
export default __webpack_public_path__ + "static/media/land_england.c666eab7a64a28c780257c8a6f3c6149.svg";
export { ForwardRef as ReactComponent };